import { useState, useEffect, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '@/context/AuthContext';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TEAM_ROLES = ['team_member', 'salon_staff'];

const ALL_ON = {
  access_products: true, access_place_orders: true, access_orders: true,
  access_quotes: true, access_invoices_payments: true, access_academy: true,
  access_client_shop: true, access_team: true,
};

const TEAM_DEFAULTS = {
  access_products: true, access_place_orders: true, access_orders: true,
  access_quotes: false, access_invoices_payments: false, access_academy: true,
  access_client_shop: false, access_team: false,
};

/* team_experience_26oct2026 — live page-access for team members.
   Refetches on every route change, window focus and each minute, so an
   owner's tick-box change takes effect without logout. */
export const useTeamAccess = () => {
  const { user, token } = useAuth();
  const isTeam = TEAM_ROLES.includes(user?.role);
  const [areas, setAreas] = useState(null);
  const [lessonsDone, setLessonsDone] = useState(0);
  const location = useLocation();

  const refresh = useCallback(async () => {
    if (!isTeam || !token) return;
    try {
      const { data } = await axios.get(`${API}/team-permissions/my-access`, { headers: { Authorization: `Bearer ${token}` } });
      setAreas(data.areas || null);
      setLessonsDone(data.academy_lessons_done || 0);
    } catch { /* keep last known */ }
  }, [isTeam, token]);

  useEffect(() => { refresh(); }, [refresh, location.pathname]);

  useEffect(() => {
    if (!isTeam) return undefined;
    const onFocus = () => refresh();
    window.addEventListener('focus', onFocus);
    const t = setInterval(refresh, 60000);
    return () => { window.removeEventListener('focus', onFocus); clearInterval(t); };
  }, [isTeam, refresh]);

  if (!isTeam) return { isTeam: false, areas: ALL_ON, lessonsDone: 0, loaded: true };
  return { isTeam: true, areas: areas || TEAM_DEFAULTS, lessonsDone, loaded: areas !== null };
};
